import { z } from "zod";

import { ShopifyTemplateTypeType } from "../dtos/shopify";

export const OnboardingStateSchema = z.object({
  activeStep: z.number(),
  selectedPlan: z.string().nullish(),
  isComplete: z.boolean(),
  progress: z.number(),
});
export type OnboardingStateType = z.infer<typeof OnboardingStateSchema>;

export const OnboardingFormAnswerSchema = z.object({
  source: z.string(),
  sourceSpecify: z.string().optional(),
});
export type OnboardingFormAnswerType = z.infer<
  typeof OnboardingFormAnswerSchema
>;

export const ThemeDtoSchema = z.object({
  id: z.number(),
  name: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  role: z.string(),
  themeStoreId: z.number().nullish(),
  previewable: z.boolean(),
  processing: z.boolean(),
  adminGraphqlApiId: z.string(),
});

export type ThemeType = z.infer<typeof ThemeDtoSchema>;

export const AssetTypeSchema = ["template"] as const;
export type AssetTypeType = (typeof AssetTypeSchema)[number];

export const AssetSchema = z.object({
  key: z.string(),
  publicUrl: z.string().nullish(),
  value: z.string().nullish(),
  themeId: z.number(),
  createdAt: z.string(),
  updatedAt: z.string(),
  contentType: z.string(),
});

export type AssetType = z.infer<typeof AssetSchema>;

export type TemplateAssetType = AssetType & {
  templateType: ShopifyTemplateTypeType;
  isDefault: boolean;
};

export const CartTransformFeaturesSchema = z.object({
  expandOperation: z.boolean(),
  mergeOperation: z.boolean(),
  updateOperation: z.boolean(),
});

export type CartTransformFeaturesType = z.infer<
  typeof CartTransformFeaturesSchema
>;

export const CartTransformSchema = z.object({
  id: z.string(),
  isPricingFunctionId: z.boolean(),
  experiences: z
    .object({
      id: z.string().uuid(),
      variationIds: z.string().array().nullish(),
    })
    .array()
    .nullish(),
  experiments: z
    .object({
      id: z.string().uuid(),
      testGroupIds: z.string().array().nullish(),
    })
    .array()
    .nullish(),
  cartTransformMode: z.string().nullish(),
  functionId: z.string(),
});

export type CartTransformType = z.infer<typeof CartTransformSchema>;

export const ShopifyMetafieldSchema = z.object({
  id: z.string().nullish(),
  metafield: z
    .object({
      createdAt: z.any(),
      id: z.string(),
      legacyResourceId: z.string().nullish(),
      key: z.string(),
      value: z.string(),
    })
    .nullish(),
});

export type ShopifyMetafieldType = z.infer<typeof ShopifyMetafieldSchema>;

export const PageViewDtoSchema = z.object({
  shopId: z.string(),
  title: z.string(),
  eventPage: z.string(),
  views: z.number(),
});

export type PageViewDto = z.infer<typeof PageViewDtoSchema>;
